// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import VerifyToken from '../components/Frontend/VerifyToken';

export const verifyTokenRoutes = (
  <>
    <Route  path="/verify_token/:token/" element={<MainLayout />}>
      <Route index element={
            <VerifyToken />
        }
        />
    </Route>
  </>
);
